import { render, staticRenderFns } from "./ProductsToTranslate.vue?vue&type=template&id=bc6231b6&"
import script from "./ProductsToTranslate.vue?vue&type=script&lang=js&"
export * from "./ProductsToTranslate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports